import PatientProfile from "./PatientProfile";

export default PatientProfile;